import { jsx as _jsx } from "react/jsx-runtime";
import { ReleaseCreate } from "../release-create.js";
const ReleaseModalStepOne = (props)=>{
    const { rowSelectionServices, rowSelectionContentBlockers } = props;
    return /*#__PURE__*/ _jsx(ReleaseCreate, {
        rowSelectionServices: rowSelectionServices,
        rowSelectionContentBlockers: rowSelectionContentBlockers
    });
};
export { ReleaseModalStepOne };
